import { Option } from 'shared/components/Select/models/Option';
import { placementTypeMapLabel } from 'shared/constants/filters/advanced/placementType';
import { EPlacementType } from 'shared/types/filters/advanced/placementType';

export const placementTypeOptions = [
  new Option(EPlacementType.StreetRetail, placementTypeMapLabel[EPlacementType.StreetRetail]),
  new Option(EPlacementType.ShoppingMall, placementTypeMapLabel[EPlacementType.ShoppingMall]),
];
